import { Component } from "@angular/core";
import { TypeConges } from "../core/model/type-conges";
import { TypeCongesService } from "../core/service/type-conges.service";

@Component({
  selector: "app-type-conges",
  templateUrl: "./type-conges.component.html",
  styleUrls: ["./type-conges.component.scss"],
})
export class TypeCongesComponent {
  typeConges: TypeConges[];

  constructor(private _typeCongesService: TypeCongesService) {}

  ngOnInit() {
    this.getAll();
  }

  getAll() {
    this._typeCongesService.getAll().subscribe(
      (data) => {
        this.typeConges = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
